import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getTeacherDashboardDataService } from "@/service/dashboard.service";
import { TeacherDashboardData } from "@/types/teacher-dashboard.model";
import { RootState } from "../index";

interface TeacherDashboardState {
  data: TeacherDashboardData | null;
  loading: boolean;
  error: string | null;
}

const initialState: TeacherDashboardState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchTeacherDashboardData = createAsyncThunk(
  "teacherDashboard/fetchData",
  async (submissionDate?: string) => {
    const response = await getTeacherDashboardDataService(submissionDate);
    return response.data.data;
  }
);

const teacherDashboardSlice = createSlice({
  name: "teacherDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeacherDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeacherDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchTeacherDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch teacher dashboard data";
      });
  },
});

// Selectors
export const selectTeacherDashboardData = (state: RootState) => state.teacherDashboard.data;
export const selectTeacherDashboardLoading = (state: RootState) => state.teacherDashboard.loading;
export const selectTeacherDashboardError = (state: RootState) => state.teacherDashboard.error;

export default teacherDashboardSlice.reducer;
